/*
 * CUSTOM (Schuhbeck): PLP filter redesign behaviors ("PLP Filter Canvas").
 * Loads after component-facets.js (defer order in
 * sections/main-collection-product-grid.liquid) and extends it from the
 * outside — the vendor file stays untouched so theme updates stay easy.
 *
 * 1. Sync: everything inside #CollectionProductGrid re-renders on each AJAX
 *    filter change, but the drawer badges / apply-button count / desktop
 *    panel head live outside it. They carry data-js-plp-sync keys and are
 *    refreshed here from the same fetched section HTML.
 * 2. Drawer openers: the sticky Filtern/Sortieren bar re-renders with the
 *    grid, so clicks are delegated at the document.
 * 3. Load more: fetches the next page as a section render and appends the
 *    product cards; without JS the button is a plain next-page link.
 * 4. Sticky offset: keeps the sticky bar below the sticky-header clone
 *    (.sticky-header.show) the header script appends to <body>.
 */

(function () {

  /* price inputs size to their content so "€ 15" reads as one snug label —
     ch-width fallback for browsers without CSS field-sizing */
  var sizePriceInputs = function () {
    if (CSS.supports && CSS.supports('field-sizing', 'content')) return;
    document.querySelectorAll('.plp-facets__price-input').forEach(function (input) {
      var len = String(input.value || input.placeholder || '0').length;
      input.style.width = (len + 0.75) + 'ch';
    });
  };

  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('plp-facets__price-input')) sizePriceInputs();
  });
  sizePriceInputs();

  /* 1. sync out-of-region elements after every facet re-render */

  var FacetsForm = customElements.get('facet-filters-form');

  if (FacetsForm && typeof FacetsForm.renderProductCount === 'function' && !FacetsForm.__plpPatched) {
    FacetsForm.__plpPatched = true;
    var origRenderProductCount = FacetsForm.renderProductCount.bind(FacetsForm);
    FacetsForm.renderProductCount = function (html) {
      origRenderProductCount(html);
      var doc = new DOMParser().parseFromString(html, 'text/html');
      document.querySelectorAll('[data-js-plp-sync]').forEach(function (el) {
        var key = el.getAttribute('data-js-plp-sync');
        var src = doc.querySelector('[data-js-plp-sync="' + key + '"]');
        if (src) el.innerHTML = src.innerHTML;
      });
      sizePriceInputs();
    };
  }

  /* 2. drawer openers (delegated — the sticky bar re-renders with the grid) */

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-js-plp-open-filters], [data-js-plp-open-sort]');
    if (!opener) return;
    var drawer = document.getElementById('site-filters-sidebar');
    if (!drawer || typeof drawer.show !== 'function') return;
    e.preventDefault();
    drawer.show();
    opener.setAttribute('aria-expanded', 'true');
    if (opener.hasAttribute('data-js-plp-open-sort')) {
      var sortRow = drawer.querySelector('[data-js-plp-sort-row]');
      if (sortRow) {
        // wait out the slide-in transition so the scroll isn't clobbered
        setTimeout(function () {
          sortRow.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }, 350);
      }
    }
  });

  /* 3. load more */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-js-plp-load-more]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('loading')) return;
    btn.classList.add('loading');

    var grid = document.getElementById('main-collection-product-grid');
    var fallback = function () { window.location.href = btn.href; };
    if (!grid || !grid.dataset.id) { fallback(); return; }

    var url;
    try {
      url = new URL(btn.href, window.location.origin);
    } catch (err) {
      fallback();
      return;
    }
    url.searchParams.set('section_id', grid.dataset.id);

    fetch(url.toString())
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var newGrid = doc.getElementById('main-collection-product-grid');
        var liveGrid = document.getElementById('main-collection-product-grid');
        if (!newGrid || !liveGrid) { fallback(); return; }

        Array.prototype.slice.call(newGrid.children).forEach(function (item) {
          liveGrid.appendChild(item);
          // same <template> unwrapping component-facets.js does after re-renders
          item.querySelectorAll('template').forEach(function (tpl) {
            var form = tpl.closest('form');
            if (form) form.append(tpl.content.cloneNode(true));
          });
        });

        var newLoadMore = doc.querySelector('.plp-load-more');
        var liveLoadMore = document.querySelector('.plp-load-more');
        if (liveLoadMore) {
          if (newLoadMore) {
            liveLoadMore.replaceWith(newLoadMore);
          } else {
            liveLoadMore.remove();
          }
        }
      })
      .catch(fallback);
  });

  /* 4. keep the sticky bar below the sticky-header clone */

  var setStickyOffset = function () {
    var clone = document.querySelector('.sticky-header');
    var offset = clone && clone.classList.contains('show') ? clone.offsetHeight : 0;
    document.documentElement.style.setProperty('--plp-sticky-offset', offset + 'px');
  };

  var watchStickyHeader = function () {
    var clone = document.querySelector('.sticky-header');
    if (!clone) return false;
    new MutationObserver(setStickyOffset).observe(clone, { attributes: true, attributeFilter: ['class'] });
    setStickyOffset();
    return true;
  };

  if (!watchStickyHeader()) {
    // the clone is appended by the header script; try again once loading settles
    window.addEventListener('load', watchStickyHeader, { once: true });
  }

})();
